import React, { useEffect, useState } from "react";
import { getTenantNotification } from "../../../../Services/NotificationApi";

// يمكنك تمرير معرف المستأجر (tenantId) كمُعطى للمكون أو تعديله حسب الحاجة
const ShowClintNotification = ({ tenantId }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tenantId) return;
    setLoading(true);
    getTenantNotification(tenantId)
      .then((res) => {
        setNotifications(res.data.notification || []);
        setLoading(false);
      })
      .catch((err) => {
        setError("حدث خطأ أثناء جلب التنبيهات");
        setLoading(false);
      });
  }, [tenantId]);

  if (loading) return <div>جاري التحميل...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      <h3>تنبيهات العميل</h3>
      {notifications.length === 0 ? (
        <div>لا توجد تنبيهات</div>
      ) : (
        <ul>
          {notifications.map((notification) => (
            <li key={notification.id} style={{ marginBottom: "1rem", borderBottom: "1px solid #eee", paddingBottom: "1rem" }}>
              <div><strong>العنوان:</strong> {notification.title}</div>
              <div><strong>الرسالة:</strong> {notification.message}</div>
              {notification.file && (
                <div>
                  <strong>الملف:</strong>{" "}
                  <a href={`${process.env.REACT_APP_API_BASE_URL || ""}/${notification.file}`} target="_blank" rel="noopener noreferrer">
                    تحميل الملف
                  </a>
                </div>
              )}
              <div><strong>تاريخ الإرسال:</strong> {new Date(notification.created_at).toLocaleString("ar-EG")}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ShowClintNotification;
